export const PREVENT_MULTIPLE_LOGIN = false
